/* =============================================================================
   MHV.RSVP — public "Are you coming?" (yes/no/maybe) widget for in-person events.
   Generic + self-mounting: any element with [data-mhv-rsvp] + data-session="CODE"
   (optionally data-ended="true") gets a widget. Works for logged-out visitors
   (anonymous RSVP captures name + phone; a browser token lets them change it) and
   logged-in customers (identified via the X-Customer-Key on window.mhvFetch).
   Backend: GET /api/rsvp/status , POST /api/rsvp. Self-injects its CSS (GUAC light).
   Currently mounted on the auction hub; the data-attr contract makes it reusable
   on any future in-person event surface.
   ============================================================================= */
(function () {
  var MHV = (window.MHV = window.MHV || {});
  var SERVER = (MHV && MHV.SERVER_URL) || 'https://mhv-viewer-app-1df0c0c61ed9.herokuapp.com';
  var STYLE_ID = 'mhv-rsvp-styles';
  var TOKEN_KEY = 'mhv_rsvp_token', NAME_KEY = 'mhv_rsvp_name', PHONE_KEY = 'mhv_rsvp_phone', MIN_KEY = 'mhv_rsvp_min';

  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }
  function lsGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function anonToken() {
    var t = lsGet(TOKEN_KEY);
    if (!t) { t = 'r-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); lsSet(TOKEN_KEY, t); }
    return t;
  }

  // Logged-in → mhvFetch (attaches X-Customer-Key, handles key readiness).
  // Logged-out → plain fetch (definitely anonymous, no key to wait on).
  function api(path, opts) {
    var loggedIn = !!window.MHV_CUSTOMER_ID;
    if (loggedIn && window.mhvFetch) {
      return window.mhvFetch(SERVER + path, opts || {}, { useCache: false }).then(function (r) { return r.json(); });
    }
    return fetch(SERVER + path, opts || {}).then(function (r) { return r.json(); });
  }


  // Wording depends on the auction's format: an online-only auction (no in-person component)
  // RSVPs to WATCHING the live stream; an in-person auction RSVPs to COMING to the venue.
  // st.inPerson === false means online-only; anything else (incl. missing) defaults to
  // in-person, the historical behaviour.
  function rsvpCopy(st) {
    if (st && st.inPerson === false) {
      return {
        yes: "I'll be watching",
        yesFull: "Yes, I'll be watching",
        ask: 'Are you going to watch the live stream?',
        inlineAsk: 'Watching the live stream? Let us know:',
        formHint: 'Add your name &amp; phone so we know you\'ll be watching:',
        tabYes: 'Watching'
      };
    }
    return {
      yes: "I'm coming",
      yesFull: "Yes, I'm coming",
      ask: 'Are you coming to the auction' + (st && st.venue && st.venue.label ? (' in ' + esc(st.venue.label)) : '') + '?',
      inlineAsk: 'Planning to come? Let us know:',
      formHint: 'Add your name &amp; phone so we know you\'re coming:',
      tabYes: "You're In"
    };
  }

  var RSVP = MHV.RSVP = {
    mount: function (el) {
      if (!el || el._rsvpMounted) return;
      el._rsvpMounted = true;
      // Target by auction/session CODE (auctions) OR raw event id (any other event).
      var sc = el.getAttribute('data-session') || '';
      var eid = el.getAttribute('data-event-id') || '';
      if (!sc && !eid) { el.hidden = true; return; }
      // Inline mode = compact light-theme block for the schedule cards/modal (default =
      // the dark corner tab used on the hub hero).
      var inline = el.getAttribute('data-inline') === '1' || el.getAttribute('data-inline') === 'true';
      var endedAttr = el.getAttribute('data-ended') === 'true';
      injectStyles();
      var q = sc ? ('session=' + encodeURIComponent(sc)) : ('eventId=' + encodeURIComponent(eid));
      api('/api/rsvp/status?' + q + '&token=' + encodeURIComponent(anonToken()))
        .then(function (d) {
          // RSVP shows for ANY event with it enabled (was in-person-only) — hide when ended/off.
          if (!d || !d.found || !d.rsvpEnabled || d.ended || endedAttr) { el.hidden = true; return; }
          render(el, { sc: sc, eid: eid, inline: inline, mine: d.mine, loggedIn: !!d.loggedIn, venue: d.venue || {}, title: d.title, inPerson: d.inPerson, livestream: !!d.livestream });
        })
        .catch(function () { el.hidden = true; });
    },
    mountAll: function () { document.querySelectorAll('[data-mhv-rsvp]').forEach(function (el) { RSVP.mount(el); }); }
  };

  // Inline block for the schedule (cards + detail modal) — light theme, horizontal pills,
  // no corner tab. Reuses the same pill/form/submit plumbing as the hub widget.
  function renderInline(el, st) {
    var copy = rsvpCopy(st);
    var opts = [['yes', '✅', copy.yes], ['maybe', '🤔', 'Maybe'], ['no', '🚫', "Can't make it"]];
    var pills = opts.map(function (o) {
      return '<button type="button" class="mhv-rsvp-pill' + (st.mine === o[0] ? ' sel' : '') + '" data-r="' + o[0] + '">' +
        '<span class="mhv-rsvp-ico">' + o[1] + '</span>' + esc(o[2]) + '</button>';
    }).join('');
    var head = st.mine ? "You're on the list — change anytime:" : copy.inlineAsk;
    el.innerHTML =
      '<div class="mhv-rsvp-inline">' +
        '<div class="mhv-rsvp-inline-head">' + esc(head) + '</div>' +
        '<div class="mhv-rsvp-pills">' + pills + '</div>' +
        '<div class="mhv-rsvp-form" hidden></div>' +
        '<div class="mhv-rsvp-msg" hidden></div>' +
      '</div>';
    el.hidden = false;
    el.querySelectorAll('.mhv-rsvp-pill').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); choose(el, st, b.getAttribute('data-r')); });
    });
  }

  function render(el, st, keepOpen) {
    if (st.inline) { renderInline(el, st); return; }
    var copy = rsvpCopy(st);
    var opts = [['yes', '✅', copy.yesFull], ['maybe', '🤔', 'Maybe'], ['no', '🚫', "Can't make it"]];
    var pills = opts.map(function (o) {
      return '<button type="button" class="mhv-rsvp-pill' + (st.mine === o[0] ? ' sel' : '') + '" data-r="' + o[0] + '">' +
        '<span class="mhv-rsvp-ico">' + o[1] + '</span>' + esc(o[2]) + '</button>';
    }).join('');
    var head = st.mine ? "You're on the list — change anytime:" : copy.ask;
    // Collapsed tab label reflects the current RSVP so the corner button is informative.
    var tabLabel = st.mine ? (st.mine === 'yes' ? copy.tabYes : st.mine === 'maybe' ? 'Maybe' : "Can't Make It") : 'RSVP';
    el.innerHTML =
      '<div class="mhv-rsvp-panel" hidden>' +
        '<button type="button" class="mhv-rsvp-x" aria-label="Minimize">&times;</button>' +
        // No 📍 address toggle (owner, 2026-10-13): the address sits right under the
        // header on the hub, and the question already names the town.
        '<div class="mhv-rsvp-head"><span class="mhv-rsvp-q">' + esc(head) + '</span></div>' +
        '<div class="mhv-rsvp-pills">' + pills + '</div>' +
        '<div class="mhv-rsvp-form" hidden></div>' +
        '<div class="mhv-rsvp-msg" hidden></div>' +
      '</div>' +
      '<button type="button" class="mhv-rsvp-tab' + (st.mine ? ' done' : '') + '">' +
        '<span class="mhv-rsvp-tab-ico">' + (st.mine ? '✓' : '✋') + '</span> ' + esc(tabLabel) +
      '</button>';
    el.hidden = false;
    var panel = el.querySelector('.mhv-rsvp-panel');
    var tab = el.querySelector('.mhv-rsvp-tab');
    function open() { if (panel) panel.hidden = false; el.classList.add('open'); lsSet(MIN_KEY, ''); }
    function close() { if (panel) panel.hidden = true; el.classList.remove('open'); lsSet(MIN_KEY, '1'); }
    if (tab) tab.addEventListener('click', open);
    var x = el.querySelector('.mhv-rsvp-x'); if (x) x.addEventListener('click', close);
    el.querySelectorAll('.mhv-rsvp-pill').forEach(function (b) {
      b.addEventListener('click', function () { choose(el, st, b.getAttribute('data-r')); });
    });
    // Open by default; stay collapsed only if the visitor previously minimized it.
    if (keepOpen || lsGet(MIN_KEY) !== '1') open();
  }

  function choose(el, st, response) {
    if (st.loggedIn) { submit(el, st, { response: response }); return; }
    var name = lsGet(NAME_KEY), phone = lsGet(PHONE_KEY);
    if (name && phone) { submit(el, st, { response: response, name: name, phone: phone, token: anonToken() }); return; }
    showAnonForm(el, st, response);
  }

  function showAnonForm(el, st, response) {
    var form = el.querySelector('.mhv-rsvp-form');
    form.innerHTML =
      '<p class="mhv-rsvp-formhint">' + rsvpCopy(st).formHint + '</p>' +
      '<input type="text" class="mhv-rsvp-in" id="mhv-rsvp-name" placeholder="Your name" value="' + esc(lsGet(NAME_KEY)) + '">' +
      '<input type="tel" class="mhv-rsvp-in" id="mhv-rsvp-phone" placeholder="Mobile number" value="' + esc(lsGet(PHONE_KEY)) + '">' +
      '<button type="button" class="mhv-rsvp-confirm" data-r="' + esc(response) + '">Confirm RSVP</button>';
    form.hidden = false;
    el.querySelectorAll('.mhv-rsvp-pill').forEach(function (b) { b.classList.toggle('sel', b.getAttribute('data-r') === response); });
    form.querySelector('.mhv-rsvp-confirm').addEventListener('click', function () {
      var nm = (form.querySelector('#mhv-rsvp-name').value || '').trim();
      var ph = (form.querySelector('#mhv-rsvp-phone').value || '').trim();
      if (!nm || !ph) { msg(el, 'Please enter your name and phone.', true); return; }
      lsSet(NAME_KEY, nm); lsSet(PHONE_KEY, ph);
      submit(el, st, { response: response, name: nm, phone: ph, token: anonToken() });
    });
  }

  function submit(el, st, body) {
    if (st.sc) body.sessionCode = st.sc; else if (st.eid) body.eventId = st.eid;
    body.source = st.inline ? 'schedule' : 'hub';
    msg(el, 'Saving…', false);
    api('/api/rsvp', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (d) {
        if (!d || !d.ok) { msg(el, (d && d.error) || 'Could not save your RSVP.', true); return; }
        st.mine = d.mine;
        render(el, st, true); // keep the panel open to show the confirmation
        msg(el, d.mine === 'yes' ? 'See you there! 🎉' : d.mine === 'maybe' ? 'Thanks — hope you can make it!' : 'Thanks for letting us know.', false);
      })
      .catch(function () { msg(el, 'Could not save your RSVP.', true); });
  }

  function msg(el, text, isErr) {
    var m = el.querySelector('.mhv-rsvp-msg');
    if (!m) return;
    m.textContent = text; m.hidden = false; m.className = 'mhv-rsvp-msg' + (isErr ? ' err' : ' ok');
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style'); s.id = STYLE_ID;
    // Corner control on the DARK hero: a collapsed teal tab (styled like the Gallery
    // button) that expands upward into a solid, legible panel. Stacks above Gallery.
    var TEAL = 'var(--mhv-brand-teal-rgb,44,95,99)';
    s.textContent = [
      // Wrapper: absolute in the hero corner (bottom-left); raised above the Gallery button.
      // z-index 2 = same layer as the hero controls, BELOW the sticky site header (whose
      // header group is z-index 3+) so the pill slides UNDER the header on scroll (SEC/UX).
      '.hub-rsvp-wrap{position:absolute;left:10px;bottom:10px;z-index:2}',
      '.hub-rsvp-wrap.has-gallery{bottom:52px}',
      // Collapsed tab — mirrors .hub-gallery-btn
      '.mhv-rsvp-tab{display:inline-flex;align-items:center;gap:5px;background:rgba(' + TEAL + ',0.6);',
      'border:1px solid rgba(' + TEAL + ',0.85);color:var(--mhv-on-dark,#fff);padding:5px 10px;border-radius:5px;',
      'font:inherit;font-size:11px;font-weight:600;letter-spacing:.5px;cursor:pointer;transition:background .2s}',
      '.mhv-rsvp-tab:hover{background:var(--mhv-brand-teal,#2C5F63)}',
      '.mhv-rsvp-tab.done{background:rgba(' + TEAL + ',0.9)}',
      '.mhv-rsvp-tab-ico{font-size:12px;line-height:1}',
      '.hub-rsvp-wrap.open .mhv-rsvp-tab{display:none}',
      // Expanded panel — opens upward from the corner; solid so it reads on the hero.
      '.mhv-rsvp-panel{position:absolute;left:0;bottom:0;width:250px;max-width:80vw;box-sizing:border-box;',
      'background:#16292b;border:1px solid rgba(' + TEAL + ',0.9);border-radius:10px;padding:13px 14px 14px;',
      'box-shadow:0 10px 30px rgba(0,0,0,0.45);text-align:center}',
      '.mhv-rsvp-x{position:absolute;top:5px;right:8px;background:none;border:none;color:#8fabab;font-size:19px;',
      'line-height:1;cursor:pointer;padding:2px}',
      '.mhv-rsvp-x:hover{color:#e8f0f0}',
      '.mhv-rsvp-head{display:flex;align-items:center;justify-content:center;gap:6px;flex-wrap:wrap;padding:0 10px}',
      '.mhv-rsvp-q{font-weight:600;font-size:12.5px;color:#e8f0f0;line-height:1.35}',
      '.mhv-rsvp-pills{display:flex;flex-direction:column;gap:6px;margin-top:10px}',
      '.mhv-rsvp-pill{display:inline-flex;align-items:center;justify-content:center;gap:6px;font:inherit;font-size:12.5px;',
      'font-weight:600;cursor:pointer;padding:7px 12px;border-radius:8px;border:1px solid rgba(94,145,152,0.5);',
      'background:rgba(94,145,152,0.16);color:#e8f0f0;transition:background .15s,border-color .15s}',
      '.mhv-rsvp-pill:hover{border-color:#5E9198;background:rgba(94,145,152,0.28)}',
      '.mhv-rsvp-pill.sel{background:#2C5F63;border-color:#5E9198;color:#fff}',
      '.mhv-rsvp-ico{font-size:14px}',
      '.mhv-rsvp-form{margin-top:9px;display:flex;flex-direction:column;gap:7px;align-items:center}',
      '.mhv-rsvp-formhint{margin:0;font-size:12px;color:#a7cccc}',
      '.mhv-rsvp-in{width:100%;box-sizing:border-box;padding:8px 11px;border:1px solid rgba(94,145,152,0.5);',
      'border-radius:8px;font:inherit;font-size:14px;color:#f0f5f5;background:rgba(255,255,255,0.08)}',
      '.mhv-rsvp-in:focus{outline:none;border-color:#5E9198;background:rgba(255,255,255,0.12)}',
      '.mhv-rsvp-in::placeholder{color:#7f9a9a}',
      '.mhv-rsvp-confirm{width:100%;font:inherit;font-size:13.5px;font-weight:700;cursor:pointer;padding:9px 18px;',
      'border-radius:8px;border:none;background:#5E9198;color:#fff}',
      '.mhv-rsvp-confirm:hover{background:#4e7f85}',
      '.mhv-rsvp-msg{margin-top:8px;font-size:12px;font-weight:600;color:#a7cccc}',
      '.mhv-rsvp-msg.ok{color:#7fd0b0}',
      '.mhv-rsvp-msg.err{color:#ff9a9a}',
      // Mobile: keep it out of the way; the panel can grow, hero scrolls.
      '@media (max-width:600px){.mhv-rsvp-panel{width:230px}}',
      // ── Inline variant (schedule cards + detail modal, GUAC light theme) ──────
      '.mhv-rsvp-inline{margin:12px 0 4px;padding:10px 12px;border:1px solid rgba(94,145,152,0.3);',
      'border-radius:8px;background:rgba(94,145,152,0.06);text-align:left}',
      '.mhv-rsvp-inline .mhv-rsvp-inline-head{font-size:13px;font-weight:700;color:#2C5F63;',
      'letter-spacing:.2px;margin-bottom:8px}',
      '.mhv-rsvp-inline .mhv-rsvp-pills{display:flex;flex-direction:row;flex-wrap:wrap;gap:6px;margin-top:0}',
      '.mhv-rsvp-inline .mhv-rsvp-pill{flex:0 1 auto;background:#fff;border:1px solid rgba(94,145,152,0.5);',
      'color:#2C5F63;padding:6px 12px}',
      '.mhv-rsvp-inline .mhv-rsvp-pill:hover{background:rgba(94,145,152,0.12);border-color:#5E9198}',
      '.mhv-rsvp-inline .mhv-rsvp-pill.sel{background:#2C5F63;border-color:#2C5F63;color:#fff}',
      '.mhv-rsvp-inline .mhv-rsvp-form{margin-top:9px;align-items:stretch}',
      '.mhv-rsvp-inline .mhv-rsvp-formhint{color:#5a6b6b}',
      '.mhv-rsvp-inline .mhv-rsvp-in{background:#fff;border:1px solid rgba(94,145,152,0.5);color:#1a2a2a}',
      '.mhv-rsvp-inline .mhv-rsvp-in:focus{border-color:#5E9198;background:#fff}',
      '.mhv-rsvp-inline .mhv-rsvp-in::placeholder{color:#9aabab}',
      '.mhv-rsvp-inline .mhv-rsvp-confirm{background:#5E9198;color:#fff}',
      '.mhv-rsvp-inline .mhv-rsvp-confirm:hover{background:#4e7f85}',
      '.mhv-rsvp-inline .mhv-rsvp-msg{color:#3f7a63}',
      '.mhv-rsvp-inline .mhv-rsvp-msg.ok{color:#3f7a63}',
      '.mhv-rsvp-inline .mhv-rsvp-msg.err{color:#c0392b}'
    ].join('');
    document.head.appendChild(s);
  }

  function boot() { RSVP.mountAll(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
